import {Component, EventEmitter, Input, Output} from "@angular/core";
import {PaginationInstance} from "ngx-pagination";
/**
 * Created by alex.y on 9/11/2017.
 */
@Component({
    selector: "management-pagination",
    templateUrl: "./managementPagination.component.html",
    moduleId: module.id.toString()
})
export class ManagementPaginationComponent {
    @Input()
    public config: PaginationInstance;

    @Output()
    public searchEventEmitter: EventEmitter<null> = new EventEmitter();

    public search(): void {
        this.searchEventEmitter.emit();
    }
}



// WEBPACK FOOTER //
// ./app/components/Managment/pagination/managementPagination.component.ts